import React from "react";

const SupportFeedbackSummaryCard = ({
  feedbackCallsPending,
  feedbackCallsCompleted,
  feedbackIssuesPending,
  feedbackIssuesResolved,
  cancellationCallsPending,
  cancellationCallsCompleted,
}) => {
  return (
    <div className="bg-[#1f1f1f] text-white p-5 rounded-lg shadow-lg flex-1 min-w-[280px]">
      <h3 className="text-[#FBB033] font-bold text-lg mb-4">Support & Feedback Calls</h3>

      <div className="space-y-4">
        {/* Feedback Calls */}
        <div className="flex flex-col space-y-1">
          <span className="text-gray-400 text-sm font-semibold uppercase tracking-wider">
            Feedback Calls
          </span>
          <div className="flex justify-between items-center text-sm">
            <span>Pending</span>
            <span className="font-medium text-red-400">{feedbackCallsPending}</span>
          </div>
          <div className="flex justify-between items-center text-sm">
            <span>Completed</span>
            <span className="font-medium text-emerald-400">{feedbackCallsCompleted}</span>
          </div>
        </div>

        {/* Feedback Issues */}
        <div className="flex flex-col space-y-1">
          <span className="text-gray-400 text-sm font-semibold uppercase tracking-wider mt-2">
            Feedback Issues
          </span>
          <div className="flex justify-between items-center text-sm">
            <span>Needs Resolution</span>
            <span className="font-medium text-red-400">{feedbackIssuesPending}</span>
          </div>
          <div className="flex justify-between items-center text-sm">
            <span>Resolved</span>
            <span className="font-medium text-emerald-400">{feedbackIssuesResolved}</span>
          </div>
        </div>

        {/* Cancellation Calls */}
        <div className="flex flex-col space-y-1">
          <span className="text-gray-400 text-sm font-semibold uppercase tracking-wider mt-2">
            Cancellation Calls
          </span>
          <div className="flex justify-between items-center text-sm">
            <span>Pending</span>
            <span className="font-medium text-red-400">{cancellationCallsPending}</span>
          </div>
          <div className="flex justify-between items-center text-sm">
            <span>Completed</span>
            <span className="font-medium text-emerald-400">{cancellationCallsCompleted}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportFeedbackSummaryCard;
